export function formatCompactDate(date) {
  if (!date || date.length < 8) {
    return '-';
  }

  const year = date.slice(0, 4);
  const month = date.slice(4, 6);
  const day = date.slice(6, 8);

  return `${day}.${month}.${year}`;
}
